/* eslint-disable @typescript-eslint/no-explicit-any */

export abstract class SmartTableData {
  abstract getData(): any[];
}
